import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { Hub } from "aws-amplify";
import styled from "styled-components";
import { isNumber } from "lodash";
import isWithinRange from "date-fns/is_within_range";
import { Dialog, DialogActions, DialogTitle, Grid } from "@material-ui/core";
import Panel from "../../atoms/panels/Panel";
import ButtonFullWidth from "../../atoms/buttons/ButtonFullWidth";
import TimeStatusAppointmentDetail from "../../molecules/TimeStatusAppointmentDetail";
import MedicalDetailAppointmentDetail from "../../molecules/MedicalDetailAppointmentDetail";
import MedicalMenuAppointmentDetail from "../../molecules/MedicalMenuAppointmentDetail";
import RejectedCommentAppointmentDetail from "../../molecules/RejectedCommentAppointmentDetail";
import PaymentDetailAppointmentDetail from "../../molecules/PaymentDetailAppointmentDetail";
import CancelPolicy from "../CancelPolicy";

import attentionPath from "../../../images/standby/attention.svg";
import FontP from "../../atoms/fonts/FontP";
import FontPBold from "../../atoms/fonts/FontPBold";
import Button from "../../atoms/buttons/Button";
import {
  APPOINTMENT_STATUS,
  FACILITY_TYPE,
  SETTLEMENT_ERROR,
  MEDICAL_MENU,
} from "../../../Utils/Constant";
import GraphQLClient from "../../../Utils/GraphQLClient";
import {
  CancelAppointment,
  GetTwilioToken,
} from "../../../Utils/GraphQLQueries";
import { japaneseList } from "../../../Resources/japaneseList";
import * as Sentry from "@sentry/browser";
import { MedicineDeliveryDetail } from "../medicineDelivery/MedicineDeliveryDetail";
import { MEDICINE_DELIVERY_METHOD } from "../../../Utils/Constant";

const DISPLAYSITES = {
  NONE: "none",
};
const ACCOUNTSTATUS = {
  ENABLED: "enabled",
};

const renderResource =
  japaneseList.organisms.AppointmentDetail.AppointmentDetailContent.render;

const CancelButton = styled(Button)`
  width: 92%;
  margin: 15px;
`;

const VideoStartButton = styled(Button)`
  width: 92%;
  margin: 15px;
`;

const HospitalDetailButton = styled(Button)`
  width: 92%;
  margin: 15px;
`;
const ButtonPopup = styled.button`
  border: none;
  background-color: transparent;
  font-size: 1.2rem;
  cursor: pointer;
`;
const FormGroup = styled.div`
  padding: 0 0 15px 0;
`;
const WarningIcon = styled.img`
  width: 25px;
  height: 25px;
`;
const PanelTabs = styled(Panel)`
  padding: 21px 15px 0px 15px;
`;
const PanelBody = styled(Panel)`
  padding: 0px 15px 15px 15px;
`;
const FontPColor = styled(FontP)`
  color: #f26666;
`;
const FontPBoldColor = styled(FontPBold)`
  color: #f26666;
`;
const GridMargin = styled(Grid)`
  margin: 0px 0px 10px 0px;
`;

const styles = () => ({
  textCenter: {
    top: "50%",
    transform: "translateY(-50%)",
    position: "absolute",
    padding: "0",
    margin: "0 auto",
    whiteSpace: "nowrap",
    left: "0",
    right: "0",
  },
});

class AppointmentDetailContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openCancelDialog: false,
      displayStartVideoChat: "none",
    };
  }

  componentDidMount() {
    this.checkAppointmentTime();
  }

  checkAppointmentTime() {
    const appointment = this.props.appointment;
    const now = new Date();
    const start = new Date(appointment.from);
    const end = new Date(appointment.to);
    if (
      appointment.status === APPOINTMENT_STATUS.BEFORE_EXAM &&
      isWithinRange(now, start, end) &&
      appointment.roomName
    ) {
      this.setState({
        displayStartVideoChat: "block",
      });
    }
  }

  isLnlnOfficeMenu = (menu) => {
    return (
      menu.medicalMenu === MEDICAL_MENU.EXAMINATION_EWP ||
      menu.medicalMenu === MEDICAL_MENU.CONSULTATION_EWP ||
      menu.medicalMenu === MEDICAL_MENU.MEDICATION_INSTRUCTION_EWP
    );
  };

  isShowCancelPolicy = (appointment) => {
    if (appointment && appointment.menu && appointment.status) {
      const cancelableStatuses = [
        APPOINTMENT_STATUS.BEFORE_EXAM,
        APPOINTMENT_STATUS.UNAPPROVED,
        APPOINTMENT_STATUS.CANCELED_PATIENT_PREVIOUS_DAY,
        APPOINTMENT_STATUS.CANCELED_PATIENT_FROM_DAY,
        APPOINTMENT_STATUS.CANCELEDBEFOREAPPROVING,
      ];
      return (
        appointment.menu.showPaymentDetailAndCancelPolicy &&
        appointment.menu.cancelPolicyContent &&
        cancelableStatuses.includes(appointment.status)
      );
    }
    return false;
  };

  handleAppointmentCancelConfirm = () => {
    this.setState({ openCancelDialog: true });
  };

  handleAfterAppointmentCancel = async () => {
    window.location.reload();
  };

  handleClose = () => {
    this.setState({ openCancelDialog: false });
  };

  handlePaymentCardUpdateClick = () => {
    this.props.history.push("/my-page/payment/card-info");
  };

  getToken = async () => {
    const createTime = this.props.appointment.createTime;
    const {
      data: { twilio },
    } = await GraphQLClient.query({
      query: GetTwilioToken,
      variables: { createTime },
    });
    if (twilio && twilio.token) {
      if (window.Android) {
        window.Android.startVideo(twilio.token);
      } else {
        this.props.history.push("/telemedicine/chat");
      }
    }
  };

  cancel = async () => {
    let errorMessange = renderResource.cancelAppointment.errors;
    let appointment = this.props.appointment;
    try {
      const body = {
        createTime: appointment.createTime,
        medicalMethod: appointment.menu.medicalMethod,
        fromOfSlot: appointment.fromOfSlot || appointment.from,
      };

      const { errors } = await GraphQLClient.mutate({
        mutation: CancelAppointment,
        variables: body,
      });

      Sentry.captureMessage("appointment-delete", Sentry.Severity.Log);

      if (errors) {
        Hub.dispatch(
          "msg",
          {
            event: "open",
            data: {
              message: errorMessange[errors[0].errorType]
                ? errorMessange[errors[0].errorType]
                : errorMessange["E01"],
              level: "error",
            },
          },
          "AppointmentDetail"
        );
        this.setState({ openCancelDialog: false });
      } else this.handleAfterAppointmentCancel();
    } catch (error) {
      Hub.dispatch(
        "msg",
        {
          event: "open",
          data: {
            message: errorMessange["E01"],
            level: "error",
          },
        },
        "AppointmentDetail"
      );
      this.setState({ openCancelDialog: false });
    }
  };

  goToHospitalDetail = (hospitalId) => {
    this.props.history.push(`/hospital/${hospitalId}`);
  };

  handleGoToLinK = () => {
    const appointment = this.props.appointment;
    if (
      appointment.medicineDelivery.deliveryMethod ===
        MEDICINE_DELIVERY_METHOD.DELIVERY &&
      appointment.medicineDelivery.accountStatus === ACCOUNTSTATUS.ENABLED &&
      appointment.medicineDelivery.displaySites !== DISPLAYSITES.NONE
    ) {
      this.props.history.push({
        pathname: `/hospital/${appointment.medicineDelivery.deliveryHospitalId}`,
      });
    } else if (
      appointment.medicineDelivery.deliveryMethod ===
      MEDICINE_DELIVERY_METHOD.GO_GET_WITH_RECEIVE_PRESCRIPTION_ATHOME
    ) {
      this.props.history.push({
        pathname: "/my-page/address/detail",
      });
    }
  };

  render() {
    const { appointment, patientInfo, showEditMedicineDelivery } = this.props;
    const isCancelableTime = new Date() < new Date(appointment.from);
    const isSelfFundedAppoimtment =
      appointment.payment && isNumber(appointment.payment.selfFundedFee) ? true : false;
    const isSelfFundedPaymentError =
      isSelfFundedAppoimtment && appointment.payment.errorCode;

    return (
      <React.Fragment>
        <PanelTabs>
          <TimeStatusAppointmentDetail appointment={appointment} />
          <MedicalDetailAppointmentDetail appointment={appointment} />
          {appointment.facilityType !== FACILITY_TYPE.PHARMACY && (
            <MedicalMenuAppointmentDetail appointment={appointment} />
          )}
          <RejectedCommentAppointmentDetail appointment={appointment} />
        </PanelTabs>
        {((appointment.payment.errorCode === SETTLEMENT_ERROR.CREDIT_CARD &&
          appointment.status === APPOINTMENT_STATUS.EXAM_COMPLETED) ||
          isSelfFundedPaymentError) && (
          <PanelBody>
            <Grid container>
              <Grid item xs={1}>
                <WarningIcon src={attentionPath} alt={""} />
              </Grid>
              <Grid item xs={11}>
                <FontPBoldColor>
                  {renderResource.paymentError.title}
                </FontPBoldColor>
              </Grid>
              <GridMargin item xs={12}>
                <FontPColor>{renderResource.paymentError.text}</FontPColor>
              </GridMargin>
              <ButtonFullWidth onClick={this.handlePaymentCardUpdateClick}>
                {renderResource.paymentError.CreditCardUpdateButton.j001}
              </ButtonFullWidth>
            </Grid>
          </PanelBody>
        )}
        {appointment.status !== APPOINTMENT_STATUS.REJECTED && (
          <React.Fragment>
            {/* WARN: showPaymentDetailAndCancelPolicyの変更時は注意が必要(#22989) */}
            {appointment.menu.showPaymentDetailAndCancelPolicy && (
              <PaymentDetailAppointmentDetail
                appointment={appointment}
                isLnlnOfficeMenu={this.isLnlnOfficeMenu(appointment.menu)}
              />
            )}
            {appointment.medicineDelivery && (
              <MedicineDeliveryDetail
                appointment={appointment}
                patientInfo={patientInfo}
                handleGoToLinK={this.handleGoToLinK}
                showEditMedicineDelivery={showEditMedicineDelivery}
              />
            )}
            {this.isShowCancelPolicy(appointment) && (
              <CancelPolicy
                facilityType={appointment.facilityType}
                menu={appointment.menu}
                cancelPolicyExamOnlineCreateByPatient={
                  appointment.status === APPOINTMENT_STATUS.UNAPPROVED
                }
                hospitalId={appointment && appointment.hospitalId}
                gtmId="hospital-detail-link"
                isLnlnOfficeMenu={this.isLnlnOfficeMenu(appointment.menu)}
                isShowFooter={true}
              />
            )}
          </React.Fragment>
        )}
        <FormGroup>
          <VideoStartButton
            style={{ display: this.state.displayStartVideoChat }}
            onClick={this.getToken}
          >
            {renderResource.div.FormGroup.CancelButton.j001}
          </VideoStartButton>
          {appointment.status === APPOINTMENT_STATUS.BEFORE_EXAM ||
          appointment.status === APPOINTMENT_STATUS.UNAPPROVED ? (
            appointment.menu.cancelAppointmentByPatient ? (
              <CancelButton
                id="cancel-appointment-button"
                onClick={this.handleAppointmentCancelConfirm}
                disabled={!isCancelableTime}
              >
                {renderResource.div.FormGroup.CancelButton.j003}
              </CancelButton>
            ) : (
              <HospitalDetailButton
                onClick={() => this.goToHospitalDetail(appointment.hospitalId)}
              >
                {renderResource.div.FormGroup.CancelButton.j002}
              </HospitalDetailButton>
            )
          ) : (
            ""
          )}
        </FormGroup>
        <Dialog
          open={this.state.openCancelDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {renderResource.div.Dialog.DialogTitle.j001}
          </DialogTitle>
          <DialogActions>
            <ButtonPopup key={0} onClick={this.handleClose}>
              {renderResource.div.Dialog.DialogActions.ButtonPopup.j001}
            </ButtonPopup>
            ,
            <ButtonPopup key={1} onClick={this.cancel}>
              {renderResource.div.Dialog.DialogActions.ButtonPopup.j002}
            </ButtonPopup>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(withRouter(AppointmentDetailContent));
